// Use this file to export feature flag keys eg:
// export const IMAGE_LIBRARY_REWORK = 'image_library_rework';
export const USER_SETTINGS = 'vsc_user_settings';
